<template>
  <b-container>
    <b-row>
      <h1>Cadastro de empresa</h1>

      <success-fade-alert ref="successFadeAlert" :msg="alert.success" />
      <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />
    </b-row>

    <b-form @submit.prevent="processForm">
      <company-crud-data
        :model="form"
        :isEditing="false"
        :modelstate="modelstate"
      />
      <b-row>
        <!-- submit button -->
        <div class="field has-text-right">
          <b-button type="submit" variant="primary" :disabled="submitted"
            >Salvar</b-button
          >
        </div>
      </b-row>
    </b-form>
  </b-container>
</template>

<script>
import AwesomeMask from "awesome-mask";
import CompanyCrudData from "@/components_rms/company/CompanyCrudData.vue";
import CompanyTabs from "@/components_rms/company/CompanyTabs.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";

export default {
  name: "Create",
  components: {
    CompanyCrudData,
    SuccessFadeAlert,
    FadeAlertDanger,
    CompanyTabs,
  },
  data: function () {
    return {
      alert: {
        error: "Verifique os dados informados",
        success: "",
      },
      sucesso: false,
      submitted: false,
      modelstate: {},
      form: {
        numeroDocumento: "",
        razaoSocial: "",
        mfaRequired: false,
        nomeFantasia: "",
        telefoneComercial: "",
        celular: "",
        email: "",
        adminUsername: "",
        adminPassword: "",
        companyTheme: "",
        embarcador: false,
        transportador: false,
        bi: false,
        tracking: false,
        checklist: false,
        planoDeViagem: false,
        mapEngine: 0,
        googleApiKey: "",
        imageQuality: 0,
        compressionLevel: 40,
        allowVideo: false,
        allowDocuments: false,
        allowOcr: false,
        allowInactiveDraftFilter: false,
        qntvehicle: 0,
      },
    };
  },
  directives: {
    mask: AwesomeMask,
  },
  methods: {
    processForm() {
      this.modelstate = {};
      this.submitted = true;
      this.$apiScheduler
        .post("/empresa/create", this.form)
        .then((response) => {
          this.sucesso = true;
          this.submitted = false;
          this.$refs.successFadeAlert.show();
          this.form = {
            numeroDocumento: "",
            razaoSocial: "",
            mfaRequired: false,
            nomeFantasia: "",
            telefoneComercial: "",
            celular: "",
            email: "",
            adminUsername: "",
            adminPassword: "",
            companyTheme: "",
            embarcador: false,
            transportador: false,
            bi: false,
            tracking: false,
            checklist: false,
            planoDeViagem: false,
            mapEngine: 0,
            googleApiKey: "",
            imageQuality: 0,
            compressionLevel: 40,
            allowVideo: false,
            allowDocuments: false,
            allowOcr: false,
            allowInactiveDraftFilter: false,
            qntvehicle: 0,
          };
        })
        .catch((error) => {
          this.submitted = false;
          console.log(error);
          console.log(error.response.data.errors);

          if (error.response.status == 400) {
            this.$refs.fadeAlertDanger.show();
            this.modelstate = error.response.data.errors;
          }
        });
    },
  },
};
</script>
